import React from 'react';

import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import { ModelOfAgency, ModelOfAgencyList } from 'src/database';

import { useListAgencysController } from 'src/controllers/Agencys/ListAgencysController';
import DropzoneScreen from 'src/components/Dropzone/Dropzone';
import LoadingScreen from 'src/components/LoadingScreen';
import { useAuth } from 'src/contexts/auth';
import classNames from 'classnames';
import { useData } from 'src/contexts/data';

const AgencysList: React.FC = () => {
    const { getAgencyListController, handleAgencyListController } = useListAgencysController();
    const { getImages } = useData();
    const { userAgencyData } = useAuth();

    if (getAgencyListController.loading) {
        return <LoadingScreen />
    };

    const actionBodyTemplate = (Agency: ModelOfAgency) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success" onClick={() => handleAgencyListController.openEditDialog(Agency)} />
            </React.Fragment>
        );
    };

    const editAgencyDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleAgencyListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getAgencyListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const HEADER_NOME = (rowData: ModelOfAgencyList) => {
        return (
            <React.Fragment>
                <span className="left-header">NOME</span>
                {rowData.NOME_ORGAO}
            </React.Fragment>
        );
    }

    const HEADER_CNPJ = (rowData: ModelOfAgencyList) => {
        return (
            <React.Fragment>
                <span className="left-header">CNPJ</span>
                {rowData.CNPJ_ORGAO}
            </React.Fragment>
        );
    }

    const HEADER_BAIRRO = (rowData: ModelOfAgencyList) => {
        return (
            <React.Fragment>
                <span className="left-header">BAIRRO</span>
                {rowData.BAIRRO_ORGAO}
            </React.Fragment>
        );
    }

    const HEADER_ENDERECO = (rowData: ModelOfAgencyList) => {
        return (
            <React.Fragment>
                <span className="left-header">ENDERECO</span>
                {rowData.ENDERECO_ORGAO}
            </React.Fragment>
        );
    }

    const HEADER_CIDADE = (rowData: ModelOfAgencyList) => {
        return (
            <React.Fragment>
                <span className="left-header">CIDADE</span>
                {rowData.NOME_CIDADE_ORGAO}
            </React.Fragment>
        );
    }

    const HEADER_CEP = (rowData: ModelOfAgencyList) => {
        return (
            <React.Fragment>
                <span className="left-header">CEP</span>
                {rowData.CEP_ORGAO}
            </React.Fragment>
        );
    }

    return (
        <div>
            <Toast ref={getAgencyListController.toast} />
            <div className="p-card p-p-4">
                <DataTable
                    className="responsive-table p-datatable-sm"
                    dataKey="ID" autoLayout
                    value={userAgencyData}
                >
                    <Column field="NOME_ORGAO" header="ÓRGÃO" body={HEADER_NOME}></Column>
                    <Column field="CIDADE_ORGAO" header="CIDADE" body={HEADER_CIDADE}></Column>
                    <Column field="BAIRRO_ORGAO" header="BAIRRO" body={HEADER_BAIRRO}></Column>
                    <Column field="ENDERECO_ORGAO" header="ENDEREÇO" body={HEADER_ENDERECO}></Column>
                    <Column field="CEP_ORGAO" header="CEP" body={HEADER_CEP}></Column>
                    <Column field="CNPJ_ORGAO" header="CNPJ" body={HEADER_CNPJ}></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid"
                style={{ width: '90%' }}
                visible={getAgencyListController.editDialog}
                onHide={handleAgencyListController.closeEditDialog}
                onShow={() => {
                    getAgencyListController.formik.setValues({
                        ...getAgencyListController.selectedAgency,
                        CIDADE_ORGAO: userAgencyData.CIDADE_ORGAO
                    })
                    getImages(getAgencyListController.selectedAgency.ID)
                }}
                footer={editAgencyDialogFooter}
                header={`Editar órgão ${getAgencyListController.selectedAgency?.NOME_ORGAO}`}
                modal
            >
                <div className="p-grid p-fluid">
                    <div className="p-field p-col-12 p-md-8">
                        <label htmlFor="nome" >Nome</label>
                        <InputText id="nome" maxLength={150}
                            {...getAgencyListController.formik.getFieldProps('NOME_ORGAO')}
                            onChange={getAgencyListController.formik.handleChange('NOME_ORGAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getAgencyListController.formik.touched.NOME_ORGAO && getAgencyListController.formik.errors.NOME_ORGAO,
                            'popup-form-inactive': !(getAgencyListController.formik.touched.NOME_ORGAO && getAgencyListController.formik.errors.NOME_ORGAO),
                        })}
                        >{getAgencyListController.formik.errors.NOME_ORGAO}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="cnpj" >CNPJ</label>
                        <InputText id="cnpj" maxLength={18}
                            {...getAgencyListController.formik.getFieldProps('CNPJ_ORGAO')}
                            onChange={getAgencyListController.formik.handleChange('CNPJ_ORGAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getAgencyListController.formik.touched.CNPJ_ORGAO && getAgencyListController.formik.errors.CNPJ_ORGAO,
                            'popup-form-inactive': !(getAgencyListController.formik.touched.CNPJ_ORGAO && getAgencyListController.formik.errors.CNPJ_ORGAO),
                        })}
                        >{getAgencyListController.formik.errors.CNPJ_ORGAO}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="bairro" >Bairro</label>
                        <InputText id="bairro" maxLength={50}
                            {...getAgencyListController.formik.getFieldProps('BAIRRO_ORGAO')}
                            onChange={getAgencyListController.formik.handleChange('BAIRRO_ORGAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getAgencyListController.formik.touched.BAIRRO_ORGAO && getAgencyListController.formik.errors.BAIRRO_ORGAO,
                            'popup-form-inactive': !(getAgencyListController.formik.touched.BAIRRO_ORGAO && getAgencyListController.formik.errors.BAIRRO_ORGAO),
                        })}
                        >{getAgencyListController.formik.errors.BAIRRO_ORGAO}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="endereço" >Endereço</label>
                        <InputText id="endereço" maxLength={200}
                            {...getAgencyListController.formik.getFieldProps('ENDERECO_ORGAO')}
                            onChange={getAgencyListController.formik.handleChange('ENDERECO_ORGAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getAgencyListController.formik.touched.ENDERECO_ORGAO && getAgencyListController.formik.errors.ENDERECO_ORGAO,
                            'popup-form-inactive': !(getAgencyListController.formik.touched.ENDERECO_ORGAO && getAgencyListController.formik.errors.ENDERECO_ORGAO),
                        })}
                        >{getAgencyListController.formik.errors.ENDERECO_ORGAO}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="cep" >CEP</label>
                        <InputText id="cep" maxLength={10}
                            {...getAgencyListController.formik.getFieldProps('CEP_ORGAO')}
                            onChange={getAgencyListController.formik.handleChange('CEP_ORGAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getAgencyListController.formik.touched.CEP_ORGAO && getAgencyListController.formik.errors.CEP_ORGAO,
                            'popup-form-inactive': !(getAgencyListController.formik.touched.CEP_ORGAO && getAgencyListController.formik.errors.CEP_ORGAO),
                        })}
                        >{getAgencyListController.formik.errors.CEP_ORGAO}</div>
                    </div>

                    <div className="p-field p-col-12">
                        <label htmlFor="ultVenda">Logo do órgão</label>
                        <div className="p-fileupload">
                            <DropzoneScreen />
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>

    );
};

export default AgencysList;